import {
  useEffect,
  useRef,
  useContext,
  useState,
} from 'react';
import propTypes from 'prop-types';
import { DialogContext } from './DialogProvider';

export function useDialogState() {
  const { activate, deactivate } = useContext(DialogContext);
  const [isOpen, setIsOpen] = useState(false);
  const dialogRef = useRef();
  const firstElementRef = useRef();
  const lastElementRef = useRef();
  const modalTriggerRef = useRef();

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  useEffect(() => { // eslint-disable-line consistent-return
    if (isOpen) {
      const dialog = dialogRef.current;
      const firstElement = firstElementRef.current;
      const lastElement = lastElementRef.current;
      const modalTrigger = modalTriggerRef.current;

      activate({
        closeModal,
        dialog,
        firstElement,
        lastElement,
        modalTrigger,
      });

      return () => deactivate({
        closeModal,
        dialog,
        firstElement,
        lastElement,
        modalTrigger,
      });
    }
  }, [isOpen, activate, deactivate]);

  return {
    isOpen,
    openModal,
    closeModal,
    modalTriggerRef,
    dialogRef,
    firstElementRef,
    lastElementRef,
  };
}

const elementRef = propTypes.shape({
  current: propTypes.instanceOf(Element),
});

export const dialogStateProps = propTypes.shape({
  isOpen: propTypes.bool,
  openModal: propTypes.func,
  closeModal: propTypes.func,
  modalTriggerRef: elementRef,
  dialogRef: elementRef,
  firstElementRef: elementRef,
  lastElementRef: elementRef,
});
